import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const maxMiddle = 3; // How many pages to show around currentPage
  if (totalPages <= 1) return null;

  const pageButtons = [];

  const addPageButton = (page) => {
    pageButtons.push(
      <button
        key={page}
        className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-secondary'}`}
        onClick={() => onPageChange(page)}
      >
        {page}
      </button>
    );
  };

  // Previous button
  pageButtons.push(
    <button
      key="prev"
      className="btn btn-sm btn-outline-secondary mx-1"
      disabled={currentPage === 1}
      onClick={() => onPageChange(currentPage - 1)}
    >
      Previous
    </button>
  );

  // Always show first page
  addPageButton(1);

  // Ellipsis after first page if needed
  const start = Math.max(2, currentPage - 1);
  const end = Math.min(totalPages - 1, currentPage + 1);

  if (start > 2) {
    pageButtons.push(<span key="start-ellipsis" className="mx-1">...</span>);
  }

  // Middle pages
  for (let i = start; i <= end; i++) {
    if (i !== 1 && i !== totalPages) {
      addPageButton(i);
    }
  }

  // Ellipsis before last page if needed
  if (end < totalPages - 1) {
    pageButtons.push(<span key="end-ellipsis" className="mx-1">...</span>);
  }

  // Always show last page
  if (totalPages > 1) {
    addPageButton(totalPages);
  }

  // Next button
  pageButtons.push(
    <button
      key="next"
      className="btn btn-sm btn-outline-secondary mx-1"
      disabled={currentPage === totalPages}
      onClick={() => onPageChange(currentPage + 1)}
    >
      Next
    </button>
  );

  return (
    <div className="d-flex justify-content-end align-items-center mt-3">
      {pageButtons}
    </div>
  );
};

export default Pagination;
